import { isValidGeoFailureReason, type GeoLocationResult } from './geo-failure-reason'

export const GEO_COMPLY_RESULT_KEY = 'geo-comply-result'

function isValidLocateDeviceResult(value: unknown): value is LocateDeviceResult {
	if (!value || typeof value !== 'object') return false
	const obj = value as Record<string, unknown>
	if (obj.status === 'Failed' && (obj.token === undefined || typeof obj.token === 'string')) return true
	if (
		obj.status === 'Success' &&
		typeof obj.subdivision === 'string' &&
		typeof obj.token === 'string'
	) {
		if (obj.country !== undefined && typeof obj.country !== 'string') return false
		return true
	}
	return false
}

export function serializeLocateDeviceResult(result: GeoLocationResult): string {
	if (!isValidLocateDeviceResult(result)) {
		throw new Error('Invalid LocateDeviceResult: must be Success with subdivision and token, or Failed with optional token')
	}
	return JSON.stringify(result)
}

export function parseLocateDeviceResult(json: string): LocateDeviceResult | null {
	try {
		const parsed = JSON.parse(json) as Record<string, unknown>
		if (!parsed || typeof parsed !== 'object') return null
		if (parsed.status === 'Failed' && (parsed.token === undefined || typeof parsed.token === 'string')) {
			const failed: LocateDeviceResult = {
				status: 'Failed',
				...(typeof parsed.token === 'string' && { token: parsed.token }),
				...(isValidGeoFailureReason(parsed.reason) && { reason: parsed.reason }),
			}
			return failed
		}
		if (
			parsed.status === 'Success' &&
			typeof parsed.subdivision === 'string' &&
			typeof parsed.token === 'string'
		) {
			const result: LocateDeviceResult = {
				status: 'Success',
				subdivision: parsed.subdivision,
				token: parsed.token,
			}
			if (typeof parsed.country === 'string') {
				result.country = parsed.country
			}
			return result
		}
		return null
	} catch {
		return null
	}
}
